import { render } from "./InternationalTradeChart.vue?vue&type=template&id=0a7396c0&scoped=true"
import script from "./InternationalTradeChart.vue?vue&type=script&lang=js"
export * from "./InternationalTradeChart.vue?vue&type=script&lang=js"

import "./InternationalTradeChart.vue?vue&type=style&index=0&id=0a7396c0&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a7396c0"]])

export default __exports__